import { useQuery } from '@tanstack/react-query';

import { sessionsService } from '../services';

import { sessionsKeys } from './useSessions';

export function useSession(id: string | undefined) {
  return useQuery({
    queryKey: sessionsKeys.detail(id ?? ''),
    queryFn: () => {
      if (!id) throw new Error('missing id');
      return sessionsService.get(id);
    },
    enabled: Boolean(id),
  });
}
